import '/assets/styles/pages/smf/if-pay-usage.scss';
// import { useEffect, useState } from 'react';

// Partials
import Icon from '@wearetla/tla-essentials-tools/partials/icon';
import Img from '@wearetla/tla-essentials-tools/partials/img';
import { useTranslation } from '/utilities/i18n';

// Static Assets
import image_step1 from '/assets/images/wallet-instructions/step-1.png';
import image_step2 from '/assets/images/wallet-instructions/step-2.png';
import image_step3 from '/assets/images/wallet-instructions/step-3.png';
import image_step4 from '/assets/images/wallet-instructions/step-4.png';

const SMFIfPay = () => {
	const { t } = useTranslation();

	return (
		<>
			<div className="usage-wrapper wrapper">
				<div className="howto-disclaimer">
					<Icon className="disclaimer-icon" name="info" />
					<div>
						<strong className="disclaimer-title">{t('Önemli Uyarı!')}</strong>
						<p className="disclaimer-text">
							{t('IF Performance harcamalarınız uygulama üzerinden gerçekleşecektir. İçeride nakit veya kredi kartı ödemesi almamaktayız.')}
						</p>
					</div>
				</div>

				<h1 className="howto-title">{t('Uygulamayı nasıl kullanırım?')}</h1>

				<ul className="howto-list">
					<li className="list-item">
						<div className="item-imagewrap">
							<Img className="imagewrap-image" src={image_step1} alt={t('Adım 1')} />
						</div>

						<div className="item-content">
							<strong className="content-title">1</strong>
							<div className="content-text">
								<p>
									{t('IF Performance uygulamasını harcamalarınızda kullanabilmek Için öncelikle üye olmalısın. Zaten üye isen giriş yap.')}
								</p>
							</div>
						</div>
					</li>
					<li className="list-item">
						<div className="item-imagewrap">
							<Img className="imagewrap-image" src={image_step2} alt={t('Adım 2')} />
						</div>

						<div className="item-content">
							<strong className="content-title">2</strong>
							<div className="content-text">
								<p>{t('Alttaki barda “Hesabım” Butonu altında “Cüzdanım” Sekmesine tıkla.')}</p>
							</div>
						</div>
					</li>
					<li className="list-item">
						<div className="item-imagewrap">
							<Img className="imagewrap-image" src={image_step3} alt={t('Adım 3')} />
						</div>

						<div className="item-content">
							<strong className="content-title">3</strong>
							<div className="content-text">
								<p>
									{t('Cüzdanındaki “Bakiye yükle” Butonuna basarak kredi kartın ile sayfadaki belirlenmiş miktarda veya istediğin miktarda yükleme yap. Eğer kredi kartın yoksa alandaki yükleme noktalarından nakit yükleme yapabilirsin.')}
								</p>
							</div>
						</div>
					</li>
					<li className="list-item">
						<div className="item-imagewrap">
							<Img className="imagewrap-image large" src={image_step4} alt={t('Adım 4')} />
						</div>

						<div className="item-content">
							<strong className="content-title">4</strong>
							<div className="content-text">
								<p>
									{t('Artık eğlencenin tadını çıkarmaya hazırsın! Alt menüde bulunan IF Pay butonu ile çıkan QR Kodu kasalarda okutarak harcama yapabilirsin.')}
								</p>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</>
	);
};

export default SMFIfPay;
